import config from "../config";
import type { APIConfigType } from "./types";

const { baseApiURL } = config;

const contentBaseUrl = `${baseApiURL}content/v1/`;
const contentBaseUrlV1o1 = `${baseApiURL}content/v1.1/`;
const clientContentBaseURL = "/api/content/";

export const API_CONFIG = {
  generalPolicies: {
    back: `${contentBaseUrl}support/general-policies`,
  },
  commonQuestions: {
    back: `${contentBaseUrl}support/common-questions`,
  },
};

export const CONTENT_API_CONFIG: APIConfigType<typeof API_CONFIG> = API_CONFIG;
